import TreatmentPage from "./TreatmentPage";

export default function Ageing() {
  return (
    <TreatmentPage
      title="Anti-Ageing Treatment"
      heroImage="/Treatment/anti-aging-drTruptis-clinic.png"
      intro="Anti-aging treatments include non-invasive procedures like Botox, dermal fillers, chemical peels, and laser resurfacing to reduce wrinkles, restore volume, and tighten skin. "
      description="Common methods include Microneedling, Thread Lifts, and, for more significant results, surgical options like a facelift or neck lift. Consistent skincare with retinoids and sunscreen is essential.
                  Collagen Stimulation: Microneedling creates micro-injuries to stimulate natural collagen production for firmer skin.
                  Skin Resurfacing: Laser treatments and chemical peels remove damaged outer layers to promote new skin growth, improving texture and tone."
      howItWorks="promote to stimulate natural collagen production for firmar skin."
      benefits={[
        "Painless",
        "Long lasting effect.",
      ]}
      beforeAfterImages={[
        "/Treatment/after-anti-ageing-treatment-truptis-clinic.jpeg",
        "/Treatment/before-anti-ageing-treatment-truptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 4-6 sessions." },
      ]}
    />
  );
}
